"use strict";
angular.module('util.trsEchartsModule', [
	'util.trsEchartsServiceModule',
	'util.trsLineModule',
	'util.trsBarModule',
	'util.trsWordCloudModule',
	'util.trsPieModule',
	"util.trsGraphModule",
	'util.trsNoEquidistantLineModule'
	]);